import { Box, Typography, Divider, Tooltip } from "@mui/joy";
import { Clock, ClipboardCheck, User, Info } from "lucide-react";
import moment from "moment";

interface ITaskHeader {
    activeTask: any;
}

export default function TaskHeader({ activeTask }: ITaskHeader) {
    const { CreatedAt, Status, AssignedTo } = activeTask || { CreatedAt: new Date(), Status: "PENDING" };
    const ownerName = AssignedTo?.Name || "Unassigned";
    const taskSummary = "No detailed summary provided for this task.";

    return (
        <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", flexDirection: "column", mb: 1.5 }}>
            <Box display={"flex"} gap={1.5} alignItems={"flex-start"}>
                <Box sx={{ mt: 0.5 }}>
                    <ClipboardCheck size={20} className="text-primary-500" />
                </Box>
                <Box>
                    <Box display={"flex"} alignItems="center" gap={1}>
                        <Typography level="body-xs" sx={{ textTransform: "uppercase", color: "text.tertiary" }}>
                            Task
                        </Typography>
                    </Box>
                    <Typography
                        level="title-lg"
                        component="div"
                        endDecorator={
                            <Tooltip title={taskSummary} placement="right" variant="outlined" sx={{ maxWidth: 300 }}>
                                <Box sx={{ display: "flex", alignItems: "center", opacity: 0.5, cursor: "help", "&:hover": { opacity: 1 } }}>
                                    <Info size={16} />
                                </Box>
                            </Tooltip>
                        }
                    >
                        {activeTask?.Name || "Task"}
                    </Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    display: "flex", alignItems: "center", gap: 1.5, mt: 1, p: 0.75, px: 1.5,
                    border: "1px solid", borderColor: "rgba(128, 128, 128, 0.2)", borderRadius: "4px",
                    bgcolor: "rgba(128, 128, 128, 0.05)", backdropFilter: "blur(12px)"
                }}
            >
                <Box display="flex" alignItems="center" gap={0.5}>
                    <User size={14} opacity={0.6} />
                    <Typography level="body-xs" color="neutral">{ownerName}</Typography>
                </Box>
                <Divider orientation="vertical" sx={{ height: 12 }} />
                <Box display="flex" alignItems="center" gap={0.5}>
                    <Box sx={{
                        width: 8, height: 8, borderRadius: "50%",
                        bgcolor: Status === "COMPLETED" ? "success.500" : "warning.500",
                        boxShadow: Status === "COMPLETED" ? "0 0 8px var(--standard-palette-success-400)" : "0 0 8px var(--standard-palette-warning-400)",
                        mr: 0.5
                    }} />
                    <Typography level="body-xs" color="neutral">{Status}</Typography>
                </Box>
                <Divider orientation="vertical" sx={{ height: 12 }} />
                <Box display="flex" alignItems="center" gap={0.5}>
                    <Clock size={14} opacity={0.6} />
                    <Typography level="body-xs" color="neutral">{moment(CreatedAt).format("MMM D, YYYY")}</Typography>
                </Box>
            </Box>
        </Box>
    );
}
